import { render, staticRenderFns } from "./HelpBlock.vue?vue&type=template&id=a712efc8&"
import script from "./HelpBlock.vue?vue&type=script&lang=js&"
export * from "./HelpBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports